
export const ADD_TO = "ADD_TO"

export const DELETE_PIZZA = "DELETE_PIZZA"

export const CHANGE_COUNT = "CHANGE_COUNT"

export const PLACE_ORDER = "PLACE_ORDER"